import React from 'react';
import { Adfox } from '../../components/Adfox';
import { BackgroundProvider } from '../../components/BackgroundProvider';
import { FiltersPanel } from '../../components/FiltersPanel';
import { Header } from '../../components/Header';
import { Main } from '../../components/Main';
import { CountryBuildingsBannersContainer } from '../CountryBuildingsBannersContainer';
import { FiltersContainer } from '../FiltersContainer';
import { FiltersTabsContainer } from '../FiltersTabsContainer';
import { GeoSwitcherWrapperContainer } from '../GeoSwitcherContainer';
import { MagazineContainer } from '../MagazineContainer';
import { PopularListContainer } from '../PopularListContainer';
import { PromoBlocksContainer } from '../PromoBlocksContainer';
import { ReviewsContainer } from '../ReviewsContainer';
import { VillagesContainer } from '../VillagesContainer';
import { BuildersProjectsBannerContainer } from '../BuildersProjectsBannerContainer';

export const HomeContainer = () => (
  <Main>
    <GeoSwitcherWrapperContainer />
    <BackgroundProvider>
      <Header>
        <FiltersPanel>
          <FiltersTabsContainer />
          <FiltersContainer />
        </FiltersPanel>
        <Adfox type="mainpageBrand" minHeight="125px" />
      </Header>
    </BackgroundProvider>
    <BuildersProjectsBannerContainer />
    <PromoBlocksContainer />
    <VillagesContainer />
    <PopularListContainer />
    <CountryBuildingsBannersContainer />
    <ReviewsContainer />
    <MagazineContainer />
  </Main>
);
